import { ButtonColor } from '@mm/constants/button-color';
import classnames from 'classnames';
import React, { MouseEvent, MutableRefObject } from 'react';
import styles from './Button.module.css';

export type ButtonProps = {
  children?: React.ReactNode;
  css?: {
    container?: string;
    leftIcon?: string;
    rightIcon?: string;
  };
  disabled?: boolean;
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => any;
  onMouseDown?: (e: MouseEvent<HTMLButtonElement>) => void;
  color?: ButtonColor;
  type?: 'submit' | 'reset' | 'button';
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  id?: string;
  size?: 'sm' | 'md' | 'lg';
};

export const Button = React.forwardRef(
  (props: ButtonProps, ref: MutableRefObject<HTMLButtonElement | null>) => {
    const {
      css,
      disabled,
      onClick,
      onMouseDown,
      children,
      leftIcon,
      rightIcon,
      id,
      color = 'blue',
      type = 'button',
      size = 'md',
    } = props;

    const hasChildren =
      children && (!Array.isArray(children) || children.filter(Boolean).length);

    const classList = classnames(
      styles.main,
      css?.container,
      styles[`color--${color}`],
      styles[`size--${size}`],
      {
        [styles.iconOnly]: leftIcon && !hasChildren,
      },
    );

    const clickHandler = (e: MouseEvent<HTMLButtonElement>) => {
      if (!disabled && onClick) {
        onClick(e);
      }
    };

    return (
      <button
        ref={ref}
        className={classList}
        onClick={clickHandler}
        onMouseDown={onMouseDown}
        type={type}
        id={id}
        disabled={disabled}
      >
        {leftIcon && (
          <span className={classnames(styles.leftIcon, css?.leftIcon)}>
            {leftIcon}
          </span>
        )}
        {children}
        {rightIcon && (
          <span className={classnames(styles.rightIcon, css?.rightIcon)}>
            {rightIcon}
          </span>
        )}
      </button>
    );
  },
);
